// src/util/noop.ts
var noop = function noop() {};
export { noop };